import React, { FC, useState } from 'react';
import { Space, Collapse } from 'antd';
import classnames from 'classnames';
import { ArrowDownOutlined, ArrowUpOutlined } from 'iglooicon';
import './index.less';

interface IItem {
  label: string;
  value: React.ReactNode;
  children?: IItem[];
  type?: 'strong' | 'total' | 'smallSpace';
  awalysShow?: boolean;
}

interface IProps {
  title: string;
  subTitle?: string;
  list: IItem[];
  className?: string;
  collapseDisabled?: boolean;
}

const prefixCls = 'global-list-item-panel';

const { Panel } = Collapse;

const ListItemPanel: FC<IProps> = ({
  title,
  subTitle,
  list,
  className,
  collapseDisabled = false,
}) => {
  const [isCollapse, setIsCollapse] = useState(false);
  const header = (
    <Space
      className={`${prefixCls}-section-title`}
      direction="vertical"
      size={2}
    >
      <div className={`${prefixCls}-section-title-row`}>
        <span className={`${prefixCls}-section-title-title`}>{title}</span>
        {!collapseDisabled && (
          <div
            className={`${prefixCls}-section-title-icon`}
            onClick={() => {
              setIsCollapse((n) => !n);
            }}
          >
            {isCollapse ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
          </div>
        )}
      </div>
      {subTitle && (
        <span className={`${prefixCls}-section-title-subtitle`}>
          {subTitle}
        </span>
      )}
    </Space>
  );
  let nodeList: any[] = [];
  let alwaysShowNodeList: any[] = [];

  list.forEach((item, index) => {
    const childList =
      item.children!?.length > 0 ? (
        <div>
          {item?.children?.map((e, i) => {
            return (
              <div
                className={`${prefixCls}-section-content-item-subitem`}
                key={i}
              >
                <span
                  className={`${prefixCls}-section-content-item-subitem-label`}
                >
                  {e.label}
                </span>
                <span
                  className={`${prefixCls}-section-content-item-subitem-label`}
                >
                  {e.value}
                </span>
              </div>
            );
          })}
        </div>
      ) : null;
    const node = (
      <React.Fragment key={index}>
        <div
          className={classnames([
            `${prefixCls}-section-content-item`,
            {
              strong: item.type === 'strong',
              total: item.type === 'total',
              smallSpace: item.type === 'smallSpace',
              'has-children': !!childList,
            },
          ])}
        >
          <span className={`${prefixCls}-section-content-item-label`}>
            {item.label}
          </span>
          <span className={`${prefixCls}-section-content-item-value`}>
            {item.value}
          </span>
        </div>
        {childList}
      </React.Fragment>
    );
    if (item.awalysShow) {
      alwaysShowNodeList.push(node);
    } else {
      nodeList.push(node);
    }
  });
  return (
    <Collapse
      className={classnames([
        prefixCls,
        {
          [className as string]: !!className,
        },
      ])}
      defaultActiveKey={['1']}
      ghost
      expandIconPosition="start"
      onChange={(keys) => {
        setIsCollapse(keys.length === 0);
      }}
      {...(collapseDisabled ? { collapsible: 'disabled' } : {})}
    >
      <Panel header={header} key="1" showArrow={false}>
        <div className={`${prefixCls}-section-content`}>{nodeList}</div>
      </Panel>
      {alwaysShowNodeList}
    </Collapse>
  );
};

export default ListItemPanel;
